import { CircularProgress, Grid2 } from "@mui/material";
import styles from "./SignupSummary.module.scss";
import CustomButton from "../../../../GlobalComponents/CustomButton/CustomButton";
import { formatIndianCurrency } from "../../../../Utils/utils";
import CouponCode from "../../../Admin/Pages/Billing/Components/Coupon/CouponCode";

function SignUpPlanSummary(props) {
  const {
    planName,
    step,
    platformDiscount,
    isSingleSite,
    billingCycle,
    noOfSites,
    country,
    couponCode,
    setCouponCode,
    appliedCoupon,
    couponError,
    onApplyCoupon,
    couponLoading,
    handleContinue,
    isDisabled,
    loading,
    yearlyPrice,
    indDiscount,
    pfAmount,
    gst,
    subTotal,
    total,
    isData,
    setIsData,
    showInput,
    setShowInput,
    isFullOrgAddress,
  } = props;

  const formattedDate = (() => {
    const currentDate = new Date();
    const nextChargeDate = new Date(currentDate);
    if (billingCycle === "Monthly") {
      nextChargeDate.setMonth(nextChargeDate.getMonth() + 1);
    } else if (billingCycle === "Yearly") {
      nextChargeDate.setFullYear(nextChargeDate.getFullYear() + 1);
    }
    return nextChargeDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  })();

  return (
    <Grid2 className={styles.mainContainer}>
      <Grid2 className={styles.label}>Plan Summary</Grid2>
      <hr className={styles.blueLine} />
      {isData === null ? (
        <Grid2 className={styles.planLoading}>
          <CircularProgress size={50} />
        </Grid2>
      ) : (
        <>
          <Grid2 className={styles.planContainer}>
            <Grid2 className={styles.cycleContainer}>
              <Grid2 className={styles.planName}>
                {isSingleSite ? "SS" : "MS"}-{planName}
              </Grid2>
              <Grid2 className={styles.plancycle}>
                {billingCycle === "Yearly" ? "(Yearly Plan)" : "(Monthly Plan)"}
              </Grid2>
            </Grid2>
            <Grid2 className={styles.planPrice}>
              {country === "India" ? `₹` : `$`}
              {formatIndianCurrency(yearlyPrice)}/
              {billingCycle === "Monthly" ? "mon" : "yr"}
            </Grid2>
          </Grid2>
          <Grid2 className={styles.nextBillingContainer}>
            <Grid2>
              {noOfSites} {noOfSites === "1" ? "Site" : "Sites"}
            </Grid2>
            <Grid2 className={styles.nextBillingLabel}>
              Next Bill {formattedDate}
            </Grid2>
          </Grid2>
          <hr className={styles.blackLine} />
          <Grid2 className={styles.addonLabel}>
            <Grid2>Add-ons</Grid2>
          </Grid2>
          <Grid2 className={styles.addonContainer}>
            <Grid2 className={styles.addons}>
              <Grid2 className={styles.addonPriceLabel}>WAF</Grid2>
              <Grid2 className={styles.addonPrice}>
                <Grid2 className={styles.addonPriceLabel}>Free</Grid2>
              </Grid2>
            </Grid2>
          </Grid2>

          <hr className={styles.blackLine2} />
          <Grid2 className={styles.couponBtn}>
            <CouponCode
              onApplyCoupon={onApplyCoupon}
              coupon={couponCode}
              setCoupon={setCouponCode}
              isCouponLoading={couponLoading}
              validCoupon={isData?.couponDiscountResponse}
              setValidCoupon={setIsData}
              showInput={showInput}
              setShowInput={setShowInput}
            />
          </Grid2>

          {!couponError && appliedCoupon && indDiscount !== 0 && (
            <Grid2 className={styles.taxText}>
              <Grid2>Coupon Discount ({appliedCoupon})</Grid2>
              <Grid2 className={styles.gstPrice}>
                - {country === "India" ? `₹` : `$`}
                {formatIndianCurrency(indDiscount?.toFixed(2))}/
                {billingCycle === "Monthly" ? "mon" : "yr"}
              </Grid2>
            </Grid2>
          )}

          {billingCycle === "Yearly" && platformDiscount !== 0 && (
            <Grid2 className={styles.taxText}>
              <Grid2>Platform Discount</Grid2>
              <Grid2 className={styles.gstPrice}>
                - {country === "India" ? `₹` : `$`}
                {formatIndianCurrency(pfAmount?.toFixed(2))}/
                {billingCycle === "Monthly" ? "mon" : "yr"}
              </Grid2>
            </Grid2>
          )}

          {country === "India" && indDiscount !== "" && (
            <Grid2 className={styles.taxText}>
              <Grid2>Sub Total</Grid2>
              <Grid2 className={styles.gstPrice}>
                {country === "India" ? `₹` : `$`}
                {formatIndianCurrency(subTotal?.toFixed(2))}/
                {billingCycle === "Monthly" ? "mon" : "yr"}
              </Grid2>
            </Grid2>
          )}

          {country === "India" && (
            <Grid2 className={styles.taxText}>
              <Grid2>GST (18%)</Grid2>
              <Grid2 className={styles.gstPrice}>
                ₹{formatIndianCurrency(gst?.toFixed(2))}/
                {billingCycle === "Monthly" ? "mon" : "yr"}
              </Grid2>
            </Grid2>
          )}

          <Grid2 className={styles.finalAmount}>
            <Grid2>Total</Grid2>
            <Grid2 className={styles.totalPrice}>
              {country === "India" ? `₹` : `$`}
              {formatIndianCurrency(total?.toFixed(2))}/
              {billingCycle === "Monthly" ? "mon" : "yr"}
            </Grid2>
          </Grid2>

          <Grid2 className={styles.button}>
            <CustomButton
              onClick={handleContinue}
              disabled={step === 1 && isDisabled}
              className={styles.btn}
            >
              {loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : step === 1 && !isFullOrgAddress ? (
                "Continue"
              ) : (
                "Continue To Payment"
              )}
            </CustomButton>
          </Grid2>
        </>
      )}
    </Grid2>
  );
}

export default SignUpPlanSummary;
